import { useMutation } from '@apollo/client'
import type { Product } from '@commerce/types/product'
import cartLinesAddMutation, {
  cartLinesAddVars,
} from '@commerce/utils/mutations/cart-lines-add'
import { Button, Quantity, useUI } from '@components/ui'
import { pinterestAddToCartEvent } from '@lib/events/addToCart'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { SelectedOptions } from '../helpers'

interface props {
  product: Product
  variantId: string
  disabled: boolean
  buttonText: string
  isStandardProduct: boolean
  productName: string
  selectedOptions?: SelectedOptions
}

const StandardProduct = ({
  product,
  variantId,
  disabled,
  buttonText,
  isStandardProduct,
  productName,
  selectedOptions,
}: props) => {
  const { t } = useTranslation('common')
  const [loading, setLoading] = useState(false)
  const [quantity, setQuantity] = useState(1)
  const { locale } = useRouter()
  const { openCartNotification, closeCartNotification } = useUI()
  // const { hits, sendEvent } = useHits()
  const handleQtyIncrease = () => setQuantity(quantity + 1)
  const handleQtyDecrease = () => setQuantity(quantity - 1)
  const [addItem] = useMutation(cartLinesAddMutation, {
    onCompleted() {
      openCartNotification(`${quantity} ${productName} ${t('added-to-cart')}`)
      setLoading(false)
      // sendEvent('conversion', hits, 'Added To Cart', {
      //   eventSubtype: 'addToCart',
      //   product: {
      //     currency: product?.price?.currencyCode,
      //     product: product?.name,
      //     productId: product?.id,
      //     variant: selectedOptions?.size || product?.variants?.[0]?.name,
      //     variantId:
      //       product?.variants?.find(
      //         (variant) =>
      //           variant?.name?.toLowerCase() ===
      //           selectedOptions?.size?.toString().toLowerCase()
      //       )?.id || product?.variants?.[0]?.id,
      //     sku:
      //       product?.variants?.find(
      //         (variant) =>
      //           variant?.name?.toLowerCase() ===
      //           selectedOptions?.size?.toString().toLowerCase()
      //       )?.sku || product?.variants?.[0]?.sku,
      //     price:
      //       product?.variants?.find(
      //         (variant) =>
      //           variant?.name?.toLowerCase() ===
      //           selectedOptions?.size?.toString().toLowerCase()
      //       )?.price || product?.variants?.[0]?.price,
      //     quantity: quantity,
      //   },
      // })
      pinterestAddToCartEvent([
        {
          product_id: product?.id || '',
          product_variant:
            selectedOptions?.size || product?.variants?.[0]?.name || '',
          product_variant_id:
            product?.variants?.find(
              (variant) =>
                variant?.name?.toLowerCase() ===
                selectedOptions?.size?.toString().toLowerCase()
            )?.id ||
            product?.variants?.[0]?.id ||
            '',
          product_price:
            product?.variants?.find(
              (variant) =>
                variant?.name?.toLowerCase() ===
                selectedOptions?.size?.toString().toLowerCase()
            )?.price ||
            product?.variants?.[0]?.price ||
            0,
          product_quantity: quantity,
          currency: product?.price?.currencyCode || 'AUD',
        },
      ])
    },
    onError() {
      setLoading(false)
    },
  })

  const addToCart = async () => {
    setLoading(true)
    addItem({
      variables: cartLinesAddVars({
        locale,
        variantId, //String(variant ? variant.id : product.variants[0]?.id)
        quantity,
      }),
      context: { locale },
    })
  }

  if (!isStandardProduct) return null
  return (
    <div className="flex gap-3 pt-10 lg:mt-auto lg:pt-0">
      <Quantity
        value={quantity}
        increase={handleQtyIncrease}
        decrease={handleQtyDecrease}
        classNames="bg-white border border-ui-grey-25 min-w-32 justify-around"
      />
      <Button
        aria-label={`${t('add-to-cart')}`}
        type="button"
        width="100%"
        onClick={addToCart}
        loading={loading}
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </div>
  )
}

export default StandardProduct
